import React from "react";

const CompanyView = ({ company, isViewMode, setIsViewMode }) => {
  return (
    isViewMode && (
      <div
        className={`modal fade ${isViewMode ? "show d-block" : ""}`}
        style={{
          display: "block",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        tabIndex="-1"
        role="dialog"
        aria-hidden={!isViewMode}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) setIsViewMode(false);
        }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            {/* Modal Header */}
            <div
              className="modal-header"
              style={{
                borderBottom: "none",
                paddingBottom: "10px",
                textAlign: "center",
              }}
            >
              <h4
                className="modal-title w-100"
                style={{
                  fontWeight: "bold",
                  color: "#343a40",
                  textAlign: "center",
                  fontSize: "24px",
                }}
              >
                Company Details
              </h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setIsViewMode(false)}
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="row gy-4">
                {/* General Information Card */}
                <div className="col-12">
                  <div
                    className="card border-0 mb-2"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "#ffffff",
                      padding: "10px",
                      textAlign: "left",
                    }}
                  >
                    <div className="card-body">
                      <h6
                        className="card-title"
                        style={{ fontWeight: "bold", fontSize: "18px" }}
                      >
                        <i
                          className="bi bi-building"
                          style={{ marginRight: "10px" }}
                        ></i>
                        Company Information
                      </h6>
                      <hr />
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Company Name:</strong>{" "}
                          {company?.company_name || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Company Code:</strong>{" "}
                          {company?.company_code || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Bank Account No:</strong>{" "}
                          {company?.bank_account_no || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Co Reg No:</strong>{" "}
                          {company?.co_regno || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Vessel Code Starting No:</strong>{" "}
                          {company?.vessal_code_starting_no || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>GST No:</strong> {company?.gst_no || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>GST %:</strong> {company?.gst_pct || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Address:</strong> {company?.address || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Telephone:</strong>{" "}
                          {company?.telephone || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Fax:</strong> {company?.fax || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Email:</strong> {company?.email || "N/A"}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default CompanyView;
